
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../grpc"

import {
    ResetPasswordResponse,
} from "../../base/account/account"

import {
    Empty,
} from "../../google/protobuf/empty"

export interface CheckPasswordExistByClientResponse {
    exist: boolean
}

export interface CheckPasswordExistByClientRequest {
    countryCode: string
    mobileNumber: string
    client?: string
}

export interface ActivateAccountByMobileNumberAndCaptchaResponse {
    done: boolean
}

export interface ActivateAccountByMobileNumberAndCaptchaRequest {
    countryCode: string
    mobileNumber: string
    captcha: string
}

export interface ActivateAccountByMobileNumberRequest {
    countryCode: string
    mobileNumber: string
}

export interface ResetMobileAccountPasswordByTokenRequest {
    password: string
}

export interface ResetMobileAccountPasswordByOriginalPasswordRequest {
    accountId: number /* 若不传则从accessToken中获取 */
    originalPassword: string /* 原密码 */
    newPassword: string /* 新密码 */
}

export interface ResetMobileAccountPasswordRequest {
    accountId: number
    password: string
}

export interface GetMobileNumberPageByAppIdRequest {
    appId: string
    pageNum: number
    pageSize: number
}

export interface GetMobileNumberPageByAppIdResponse {
    result: Array<MobileNumberByAccountResult>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
}

export interface GetMobileNumberPageByAccountsRequest {
    accountIds: Array<number>
    pageNum: number
    pageSize: number
}

export interface GetMobileNumberPageByAccountsResponse {
    result: Array<MobileNumberByAccountResult>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
}

export interface GetByCreateTimestampBetweenRequest {
    startTimestamp: number
    endTimestamp: number
}

export interface GetByCreateTimestampBetweenResponse {
    accountIds: Array<number>
}

export interface GetByMobileNumberContainsRequest {
    mobileNumber: string
}

export interface GetByMobileNumberContainsResponse {
    accountIds: Array<number>
}

export interface GetCreationTimestampByAccountIdsRequest {
    accountIds: Array<number>
}

export interface GetCreationTimestampByAccountIdsResponse {
    account: Array<CreationTimestampByAccountIds>
}

export interface CreationTimestampByAccountIds {
    accountId: number
    creationTimestamp: number
}

export interface BindingAccountIdForMobileNumberRequest {
    mobileNumber: string
    countryCode: string
}

export interface BindingAccountIdForMobileNumberResponse {
    mobileAccountId: number
}

export interface CheckMobileNumberExistenceRequest {
}

export interface CheckMobileNumberExistenceResponse {
    isExisted: boolean
}

export interface GetMobileNumberByAccountsRequest {
    accountIds: Array<number>
}

export interface GetMobileNumberByAccountsResponse {
    result: Array<MobileNumberByAccountResult>
}

export interface RegisterByPasswordRequest {
    countryCode: string
    mobileNumber: string
    captcha?: string
    password?: string
    client?: string
    activated?: boolean
}

export interface SetPasswordForMobileRequest {
    countryCode: string
    mobileNumber: string
    captcha?: string
    password?: string
}

export interface SetPasswordForMobileResponse {
    isSuccess: boolean
}

export interface RegisterByPasswordResponse {
    accessToken: string
    accountId: number
    expiresTimestamp: number
    activated: boolean
    refreshToken: string /* 刷新的token，有效期30天 */
    expiresIn: number /* 在...时间（毫秒）内到期 */
}

export interface RegisterByCaptchaRequest {
    countryCode: string
    mobileNumber: string
    captcha: string
    client?: string
}

export interface RegisterByCaptchaResponse {
    accessToken: string
    accountId: number
    expiresTimestamp: number
    activated: boolean
    refreshToken: string /* 刷新的token，有效期30天 */
    expiresIn: number /* 在...时间（毫秒）内到期 */
}

export interface RegisterRequest {
    countryCode: string
    mobileNumber: string
    client?: string
    activated?: boolean
}

export interface RegisterResponse {
    accountId: number
    accessToken: string
    expiresTimestamp: number
    activated: boolean
    refreshToken: string /* 刷新的token，有效期30天 */
    expiresIn: number /* 在...时间（毫秒）内到期 */
}

export interface GetAccountIdRequest {
    countryCode: string
    mobileNumber: string
}

export interface GetAccountIdResponse {
    accountId: number
}

export interface IsRegisteredRequest {
    countryCode: string
    mobileNumber: string
}

export interface IsRegisteredResponse {
    isRegistered: boolean
    activated: boolean
}

export interface LoginByPasswordRequest {
    countryCode: string
    mobileNumber: string
    password: string
    client?: string
}

export interface LoginByPasswordResponse {
    accessToken: string
    activated: boolean
    accountId: number
    expiresTimestamp: number
    refreshToken: string /* 刷新的token，有效期30天 */
    expiresIn: number /* 在...时间（毫秒）内到期 */
}

export interface LoginByCaptchaRequest {
    countryCode: string
    mobileNumber: string
    captcha: string
    client?: string
}

export interface LoginByCaptchaResponse {
    accessToken: string
    activated: boolean
    accountId: number
    expiresTimestamp: number
    refreshToken: string /* 刷新的token，有效期30天 */
    expiresIn: number /* 在...时间（毫秒）内到期 */
}

export interface MobileNumberByAccountResult {
    accountId: number
    mobileNumber: string
    timestamp: number
}

/* 手机帐号服务 */
export class MobileAccountService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* 密码注册 */
    async registerByPassword(request: RegisterByPasswordRequest): Promise<RegisterByPasswordResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/RegisterByPassword"
        return await this.call(method, path, request) as RegisterByPasswordResponse
    }
    
    /* 为电话设置密码 */
    async setPasswordForMobile(request: SetPasswordForMobileRequest): Promise<SetPasswordForMobileResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/SetPasswordForMobile"
        return await this.call(method, path, request) as SetPasswordForMobileResponse
    }
    
    /*验证码注册 */
    async registerByCaptcha(request: RegisterByCaptchaRequest): Promise<RegisterByCaptchaResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/RegisterByCaptcha"
        return await this.call(method, path, request) as RegisterByCaptchaResponse
    }
    
    /* 预注册模块 */
    async register(request: RegisterRequest): Promise<RegisterResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/Register"
        return await this.call(method, path, request) as RegisterResponse
    }
    
    /* 内部调用，根据手机号码获取 AccountId，用于关联登录账号。
 TODO 添加系统模块调用权限。 */
    async getAccountId(request: GetAccountIdRequest): Promise<GetAccountIdResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/GetAccountId"
        return await this.call(method, path, request) as GetAccountIdResponse
    }
    
    /*验证注册 */
    async isRegistered(request: IsRegisteredRequest): Promise<IsRegisteredResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/IsRegistered"
        return await this.call(method, path, request) as IsRegisteredResponse
    }
    
    /*密码登录 */
    async loginByPassword(request: LoginByPasswordRequest): Promise<LoginByPasswordResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/LoginByPassword"
        return await this.call(method, path, request) as LoginByPasswordResponse
    }
    
    /*验证码登录 */
    async loginByCaptcha(request: LoginByCaptchaRequest): Promise<LoginByCaptchaResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/LoginByCaptcha"
        return await this.call(method, path, request) as LoginByCaptchaResponse
    }
    
    /* 根据accountId获取手机号码 */
    async getMobileNumberByAccounts(request: GetMobileNumberByAccountsRequest): Promise<GetMobileNumberByAccountsResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/GetMobileNumberByAccounts"
        return await this.call(method, path, request) as GetMobileNumberByAccountsResponse
    }
    
    /* 根据access Token查看有无相应的用户 */
    async checkMobileNumberExistence(request: CheckMobileNumberExistenceRequest): Promise<CheckMobileNumberExistenceResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/CheckMobileNumberExistence"
        return await this.call(method, path, request) as CheckMobileNumberExistenceResponse
    }
    
    /* 为accountId绑定上手机号码 */
    async bindingAccountIdForMobileNumber(request: BindingAccountIdForMobileNumberRequest): Promise<BindingAccountIdForMobileNumberResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/BindingAccountIdForMobileNumber"
        return await this.call(method, path, request) as BindingAccountIdForMobileNumberResponse
    }
    
    async getCreationTimestampByAccountIds(request: GetCreationTimestampByAccountIdsRequest): Promise<GetCreationTimestampByAccountIdsResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/GetCreationTimestampByAccountIds"
        return await this.call(method, path, request) as GetCreationTimestampByAccountIdsResponse
    }
    
    async getByMobileNumberContains(request: GetByMobileNumberContainsRequest): Promise<GetByMobileNumberContainsResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/GetByMobileNumberContains"
        return await this.call(method, path, request) as GetByMobileNumberContainsResponse
    }
    
    async getByCreateTimestampBetween(request: GetByCreateTimestampBetweenRequest): Promise<GetByCreateTimestampBetweenResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/GetByCreateTimestampBetween"
        return await this.call(method, path, request) as GetByCreateTimestampBetweenResponse
    }
    
    async getMobileNumberPageByAccounts(request: GetMobileNumberPageByAccountsRequest): Promise<GetMobileNumberPageByAccountsResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/GetMobileNumberPageByAccounts"
        return await this.call(method, path, request) as GetMobileNumberPageByAccountsResponse
    }
    
    async getMobileNumberPageByAppId(request: GetMobileNumberPageByAppIdRequest): Promise<GetMobileNumberPageByAppIdResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/GetMobileNumberPageByAppId"
        return await this.call(method, path, request) as GetMobileNumberPageByAppIdResponse
    }
    
    /* 重置密码 */
    async resetMobileAccountPassword(request: ResetMobileAccountPasswordRequest): Promise<ResetPasswordResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/ResetMobileAccountPassword"
        return await this.call(method, path, request) as ResetPasswordResponse
    }
    
    /* 重置密码 */
    async resetMobileAccountPasswordByToken(request: ResetMobileAccountPasswordByTokenRequest): Promise<ResetPasswordResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/ResetMobileAccountPasswordByToken"
        return await this.call(method, path, request) as ResetPasswordResponse
    }
    
    /* 根据原密码修改密码 */
    async resetMobileAccountPasswordByOriginalPassword(request: ResetMobileAccountPasswordByOriginalPasswordRequest): Promise<ResetPasswordResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/ResetMobileAccountPasswordByOriginalPassword"
        return await this.call(method, path, request) as ResetPasswordResponse
    }
    
    /* 根据手机号激活账户 */
    async activateAccountByMobileNumberAndCaptcha(request: ActivateAccountByMobileNumberAndCaptchaRequest): Promise<ActivateAccountByMobileNumberAndCaptchaResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/ActivateAccountByMobileNumberAndCaptcha"
        return await this.call(method, path, request) as ActivateAccountByMobileNumberAndCaptchaResponse
    }
    
    /* 根据手机号激活账户 */
    async activateAccountByMobileNumber(request: ActivateAccountByMobileNumberRequest): Promise<Empty> {
        const method = "post"
        const path = "/base.account.MobileAccountService/ActivateAccountByMobileNumber"
        return await this.call(method, path, request) as Empty
    }
    
    /* 根据手机号查看密码是否存在 */
    async checkPasswordExistByClient(request: CheckPasswordExistByClientRequest): Promise<CheckPasswordExistByClientResponse> {
        const method = "post"
        const path = "/base.account.MobileAccountService/CheckPasswordExistByClient"
        return await this.call(method, path, request) as CheckPasswordExistByClientResponse
    }
    
}
